import { unlinkAccount } from 'services/auth';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from 'store/resources';

export const ThunkUnlinkExternalAccount = createAsyncThunk<boolean, number>(
  `${storeResources.AUTH}/unlinkAccount`,
  payload => unlinkAccount(payload).then(r => r.data),
);
